import styles from './App.module.css'
import "react-toastify/dist/ReactToastify.css";
import cx from "classnames";
import Navigation from "./components/Navigation";
import {useGlobalContext} from "./contexts/GlobalContext";
import {useMemo} from "react";
import ZrRouter from "./ZrRouter";

const Admin = () => {
    const {useFullscreen: {fullscreen}} = useGlobalContext()
    const title = useMemo(() => {
        const wrapper = document.getElementById('zr-wrapper')
        return  (wrapper?.dataset.title ?? 'ZR')
    }, [])

    const links = useMemo(() => {
        return [
            {route: 'overview', name: 'Übersicht'},
        ] as any
    }, [])

    return (
        <div className={cx(styles["zr-main-container"], fullscreen && styles["zr-fullscreen"]) }>
            <Navigation title={title} links={links}/>
            <div className={cx(styles["zr-main-content"]) }>
                <ZrRouter/>
            </div>
        </div>
    )
}

export default Admin;
